import axios, { AxiosResponse, AxiosError } from 'axios'
import { config } from '@/config'
import { TCSAPIResponse } from '@/types/types'
import { formatResponse } from './helpers/formatResponse'
import {
  AcceptInviteBody,
  ChangePasswordRequestBody,
  InvitedUsersResponse,
  InviteUserRequestBody,
  UpdatePersonalDetailsRequestBody,
  UpdateUserRoleRequestBody,
  UserMe,
  UsersResponse,
  ValidateInviteResponseData
} from '@/types/users'

export const UserAPI = {
  getCurrentUserDetailsByToken: async (token: string) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'GET',
        url: `${config.apiUrl}/v1/users/me`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      return formatResponse<UserMe>(response.data, null)

    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<UserMe>(null, error as AxiosError)
    }
  },
  changePassword: async (token: string, body: ChangePasswordRequestBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/auth/change-password`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: body
      })

      return formatResponse<TCSAPIResponse>(response.data, null)

    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  },
  updatePersonalDetails: async (
    token: string,
    body: UpdatePersonalDetailsRequestBody
  ) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'PATCH',
        url: `${config.apiUrl}/v1/users`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: body
      })

      return formatResponse<TCSAPIResponse>(response.data, null)

    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  },
  getAll: async (token: string) => {
    try {
      const acceptedUsers: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'GET',
        url: `${config.apiUrl}/v1/users`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<UsersResponse>(acceptedUsers.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<UsersResponse>(null, error as AxiosError)
    }
  },
  getAllInvitedUser: async (token: string) => {
    try {
      const invitedUsers: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'GET',
        url: `${config.apiUrl}/v1/users/invites?status=invited`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<InvitedUsersResponse>(invitedUsers.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<InvitedUsersResponse>(null, error as AxiosError)
    }
  },
  inviteUser: async (token: string, body: InviteUserRequestBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/users/invite`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: body
      })

      return formatResponse<TCSAPIResponse>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  },
  revokeInvite: async (token: string, userInviteId: string) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/users/invite/revoke/${userInviteId}`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      return formatResponse<TCSAPIResponse>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  },
  validateInviteToken: async (token: string) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/users/validate-invite`,
        data: {
          inviteToken: token
        }
      })

      return formatResponse<ValidateInviteResponseData>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<ValidateInviteResponseData>(null, error as AxiosError)
    }
  },
  acceptInvite: async (body: AcceptInviteBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/users/accept-invite`,
        data: body
      })

      return formatResponse<TCSAPIResponse>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  },
  deleteUser: async (token: string, userId: string) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'DELETE',
        url: `${config.apiUrl}/v1/organizations/users/${userId}`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      return formatResponse<TCSAPIResponse>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  },
  update: async (token: string, userId: string, body: UpdateUserRoleRequestBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'PATCH',
        url: `${config.apiUrl}/v1/organizations/users/${userId}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: body
      })

      return formatResponse<TCSAPIResponse>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  }
}
